export default {
  completed_transaction: 'Completed Transaction',
  lastest_update: 'Latest Update',
  month_to_date_transaction_with_pbi: 'Month to date Transaction With PBI',
  shipment_completed: 'Shipment Completed'
};
